module.exports = __webpack_public_path__ + "img/logo.8c3a7dcd.png";